// @flow

import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { translate } from '../../helpers/global'

type Props = {
  globalGetLanguages: string,
  dropdownId?: string
}

const DropdownTalentAcqMobile = ({ globalGetLanguages, dropdownId = "talent-acq-drop" }: Props) => {
  // Define content for each section (simplified for mobile)
  const contentSections = {
    platform: [
      { to: '/talent-acquisition/astrnt-platform/astrnt-recommends', text: 'ASTRNT Recommends' },
      { to: '/talent-acquisition/astrnt-platform/ai-structured-video-interview', text: 'AI Interview' },
      { to: '/talent-acquisition/astrnt-platform/ai-structured-video-interview', text: 'Structured Video Interview' },
      { to: '/talent-acquisition/skill-validation', text: 'Skill Validation' },
      { to: '/talent-acquisition/skill-validation', text: 'Assessments' },
      { to: '/apis', text: 'APIs' }
    ],
    solutions: [
      { to: '/nextgen-assessment-center?utm_content=talent-acquisition', text: 'NextGen Assessment Center' },
      { to: '/nextgen-rpo', text: 'NextGen RPO' },
      { to: '/talent-acquisition/graduate', text: 'Graduate' },
      { to: '/talent-acquisition/professional', text: 'Professional' },
      { to: '/talent-acquisition/technical', text: 'Technical' },
      { to: '/talent-acquisition/hourly', text: 'Hourly' }
    ]
  }

  return (
    <div id={dropdownId} className="dropdown-for hide">
      <div>
        <a href="#" className="a-for">
          <span>ASTRNT Platform</span>
          <i className="fas fa-angle-down" />
        </a>
        <div style={{display: 'none'}}>
          {contentSections.platform.map((link, index) => (
            <Link key={index} to={link.to}>{link.text} <i className="fas fa-arrow-right"></i></Link>
          ))}
        </div>
      </div>
      <hr/>

      <div>
        <a href="#" className="a-for">
          <span>Solutions & Use Cases</span>
          <i className="fas fa-angle-down" />
        </a>
        <div style={{display: 'none'}}>
          {contentSections.solutions.map((link, index) => (
            <Link key={index} to={link.to}>{link.text} <i className="fas fa-arrow-right"></i></Link>
          ))}
        </div>
      </div>
      <hr/>
    </div>
  )
}

export default DropdownTalentAcqMobile